export function buildUpdateOrderPayload({
  existingPayload,
  basePayload,
  transaction,
  paymentVerify,
  orderCancelled,
  orderFailed,
  paymentFailedStatus,
  flow2,
  totalPayableAmount,
  orderId,
  correlationId,
}) {
  let payload = existingPayload ? { ...existingPayload } : { ...basePayload };
  return {
    ...payload,
    ...(paymentVerify && {
      paymentVerify: [
        {
          ...transaction,
          paymentId: transaction?.razorpay_payment_id,
          orderid: transaction?.razorPayOrderId,
          signature: transaction?.razorpay_signature,
        },
      ],
    }),
    ...(orderCancelled && {
      paymentStatus: paymentFailedStatus,
      orderStatus: "Cancelled",
    }),
    ...(orderFailed && {
      paymentStatus: paymentFailedStatus,
      orderStatus: "Failed",
      paymentErrorLog: JSON.stringify(paymentFailedStatus?.error),
    }),
    id: orderId,
    correlationId,
    ...(flow2 && totalPayableAmount === 0 && { orderStatus: "Completed" }),
  };
}
